import { CLICK_THROUGH_LINK } from '../fields'

export const getAdClickThroughLink = ad => {
  return ad?.exit_events?.[0][CLICK_THROUGH_LINK]
}
